import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import HeroContent from "./HeroContent";
import "./BannerStyle/HeroSlider.css";

const SliderData = [
  {
    image: "/PropertyImage/gl-banner1.webp",
    title: "OUR ICONIC CITY",
    des: "A place where your dreams come alive, stories are written in every street, and unforgettable memories are waiting around every corner.",
  },
  {
    image: "/PropertyImage/gl-banner5.webp",
    title: "LOUNGE & RELAXATION",
    des: "Experience serene community living with an elegantly designed rooftop lounge, ideal for cozy evenings and family gatherings.",
  },
  {
    image: "/PropertyImage/gl-banner3.webp",
    title: "SWIMMING POOL",
    des: "Elevate your daily routine with a premium rooftop swimming pool, offering refreshing views and modern architectural perfection.",
  },
  {
    image: "/PropertyImage/gl-banner4.webp",
    title: "KIDS PLAY ZONE",
    des: "A safe, vibrant outdoor playground tailored for your children, providing fun-filled leisure and active play right at home.",
  },
];

export default function Banner() {
  return (
    <>
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={false}
        modules={[Autoplay, Pagination, Navigation]}
        className="hero-swiper"
      >
        {SliderData.map((slide, index) => (
          <SwiperSlide key={index} className="swiper-slide-container">
            {/* ১. ব্লার লেয়ার (Blur Layer) */}
            <div className="image-blur-overlay"></div>

            {/* ২. টেক্সট ও কনটেন্ট লেয়ার */}
            <div className="slide-overlay">
              <HeroContent slide={slide} />
            </div>

            {/* ৩. ব্যানার ইমেজ */}
            <img
              className="slide-image"
              src={slide.image}
              alt={`slide-${index}`}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}
